import { Component, Input } from '@angular/core'

import {
  AEM_ERROR_CONTENT_FOUR,
  AEM_ERROR_CONTENT_ONE,
  AEM_ERROR_CONTENT_THREE,
  AEM_ERROR_CONTENT_TWO,
  AEM_ERROR_HEADER,
} from '../../../../constants/constant.content'

@Component({
  selector: 'aem-error-page',
  templateUrl: './aem-error-page.component.html',
  styleUrls: ['./aem-error-page.component.scss'],
})
export class AemErrorPageComponent {
  @Input() FUND_LITERATURE_ERROR_SVG_URL: any
  @Input() FUND_LITERATURE_ERROR_HOME_URL: any
  protected readonly AEM_ERROR_HEADER = AEM_ERROR_HEADER
  protected readonly AEM_ERROR_CONTENT_ONE = AEM_ERROR_CONTENT_ONE
  protected readonly AEM_ERROR_CONTENT_TWO = AEM_ERROR_CONTENT_TWO
  protected readonly AEM_ERROR_CONTENT_THREE = AEM_ERROR_CONTENT_THREE
  protected readonly AEM_ERROR_CONTENT_FOUR = AEM_ERROR_CONTENT_FOUR
}
